export { default } from './ModalForgotPassword';
